import { List, Record } from 'immutable'
import { IShareContact, ShareContact } from './ShareContact'

export interface IContactEmailAddressesResult {
  contacts: List<IShareContact>
  timestamp: number
}

const ContactEmailAddressesResultRecord = Record({
  contacts: List<ShareContact>(),
  timestamp: 0,
})

export class ContactEmailAddressesResult
  extends ContactEmailAddressesResultRecord
  implements IContactEmailAddressesResult {
  public static fromJS(initialState?: Partial<IContactEmailAddressesResult>) {
    if (!initialState) {
      return new ContactEmailAddressesResult()
    }

    const { contacts, ...rest } = initialState
    return new ContactEmailAddressesResult({
      contacts: contacts
        ? List(contacts.map((r) => ShareContact.fromJS(r)))
        : List<ShareContact>(),
      ...rest,
    })
  }

  public readonly contacts: List<ShareContact>
  public readonly timestamp: number

  constructor(initialState?: Partial<ContactEmailAddressesResult>) {
    initialState ? super(initialState) : super()
  }
}
